import AlertBanner from 'components/AlertBanner'

export default function BlogLayout({
  preview,
  loading,
  children,
}: {
  preview: boolean
  loading?: boolean
  children: React.ReactNode
}) {
  return (
    <div className="min-h-screen flex flex-col overflow-hidden">
      {/* Alert Banner */}
      <AlertBanner preview={preview} loading={loading} />

      {/* Main Content */}
      <main className="flex-grow container mx-auto px-4 sm:px-6 py-4">
        {children}
      </main>
    </div>
  )
}
